import { Flex } from '@servicetitan/anvil2';
import { FinancingDetails } from './FinancingDetails';
import { Applicant } from './Applicant';
import { MailingAddress } from './MailingAddress';
import { CoApplicant } from './CoApplicant';
import { ServiceProperty } from './ServiceProperty';
import { Disclaimer } from './Disclaimer';
import { ApplicationDataStore } from '../application/ApplicationDataStore';
import { useProviderConfig } from '@servicetitan/financing-workflow-shared';
import { JobDetails } from './JobDetails';

export const Container = () => {
    const { applicationData } = ApplicationDataStore.useStore();
    const { hasMailingAddress } = useProviderConfig();

    return (
        <Flex
            direction="column"
            gap="4"
            style={{ marginTop: '45px', minWidth: '320px', maxWidth: '845px' }}
            alignSelf="center"
            role="list"
        >
            <FinancingDetails />
            <Applicant />
            {hasMailingAddress ? (
                <>
                    <MailingAddress />
                    <ServiceProperty />
                </>
            ) : (
                <JobDetails />
            )}

            {applicationData?.coApplicant?.hasCoApplicant && <CoApplicant />}
            <Disclaimer />
        </Flex>
    );
};
